import { render } from "./FooterSocial.vue?vue&type=template&id=ea1e2568&scoped=true"
import script from "./FooterSocial.vue?vue&type=script&lang=js"
export * from "./FooterSocial.vue?vue&type=script&lang=js"

import "./FooterSocial.vue?vue&type=style&index=0&id=ea1e2568&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ea1e2568"

export default script